import React from "react";

/**
 * The last line between an operator and a blank white page.
 *
 * <p>React 18 unmounts the whole tree on an uncaught render/effect error, and the result is a
 * completely white screen with no message — which operators can only describe as "it threw me out",
 * and which nobody can diagnose from the outside because nothing reaches the server. This shows what
 * actually broke (so a screenshot is a bug report), keeps the session, and offers a reload.
 */
export default class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {error: null, info: null};
    }

    static getDerivedStateFromError(error) {
        return {error};
    }

    componentDidCatch(error, info) {
        this.setState({info});
        try {
            console.error("[app] uncaught render error", error, info?.componentStack);
        } catch (e) { /* nothing */ }
    }

    render() {
        if (!this.state.error) return this.props.children;
        const err = this.state.error;
        const detail = [
            String(err && (err.stack || err.message || err)),
            this.state.info?.componentStack || "",
            "path: " + (typeof window !== "undefined" ? window.location.pathname : ""),
            "ua: " + (typeof navigator !== "undefined" ? navigator.userAgent : ""),
        ].join("\n\n");
        return (
            <div dir="rtl" style={{
                minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
                padding: 24, fontFamily: "inherit", background: "#fff", color: "#222",
            }}>
                <div style={{maxWidth: 720, width: "100%"}}>
                    <h2 style={{marginBottom: 8}}>مشکلی در نمایش پنل پیش آمد</h2>
                    <p style={{marginBottom: 16, color: "#555"}}>
                        شما هنوز وارد سیستم هستید. لطفاً صفحه را دوباره بارگذاری کنید؛ اگر تکرار شد، از همین صفحه اسکرین‌شات بگیرید و برای پشتیبانی فنی بفرستید.
                    </p>
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        style={{
                            padding: "10px 18px", fontSize: 15, borderRadius: 8, border: "none",
                            background: "#1677ff", color: "#fff", cursor: "pointer", marginBottom: 16,
                        }}
                    >
                        بارگذاری مجدد
                    </button>
                    <pre dir="ltr" style={{
                        whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 11, lineHeight: 1.5,
                        background: "#f6f6f6", border: "1px solid #ddd", borderRadius: 8, padding: 12,
                        maxHeight: 320, overflow: "auto", textAlign: "left",
                    }}>{detail}</pre>
                </div>
            </div>
        );
    }
}
